import axios, { AxiosError } from 'axios';
import { signInService } from './auth';
import { handleAuthError } from '../../services/authErrorHandler';

export const accessToken = localStorage.getItem('accessToken') || '';

export const API_URL = process.env.REACT_APP_API_URL;

export const $api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

$api.interceptors.request.use(config => {
  const accessToken = localStorage.getItem('accessToken');
  config.headers['Authorization'] = `${accessToken}`;
  return config;
});

$api.interceptors.response.use(
  config => {
    return config;
  },
  async error => {
    const originalRequest = error.config;

    // Handle specific auth errors (password changed, admin deactivated)
    if (error instanceof AxiosError && handleAuthError(error)) {
      return Promise.reject(error);
    }

    if (
      error instanceof AxiosError &&
      error.response?.status === 401 &&
      error.config &&
      !originalRequest._isRetry &&
      !error.config.url?.includes('/api/auth/refresh')
    ) {
      originalRequest._isRetry = true;
      try {
        await signInService.sendRefreshRequest();
        return $api.request(originalRequest);
      } catch (_) {
        localStorage.removeItem('accessToken');
        window.location.replace('/#/');
      }
    }
    throw error;
  }
);
